import { api } from 'app/utils/api/helpers'

export const getUserProfile = (agencyGUID = '') => {
  return api.get(`agencies/${agencyGUID}/userprofile`)
}
